import { createClient } from 'contentful';

const SPACE_ID = 'w5ok1kxsorzp';
const ACCESS_TOKEN =
  'bb5eb5ea1e405cd755452539d25257ecbc2d40bb596f84db45d4f64322d9ec3d';

const client = createClient({
  space: SPACE_ID,
  accessToken: ACCESS_TOKEN,
});

export default new Promise((resolve, reject) =>
  client
    .getEntry('2yezfc61tuMga2AeskioSK')
    .then(resolve)
    .catch(reject)
);



// WEBPACK FOOTER //
// ./src/getStringsFromContentful.js